import {
  IBitBuilder,
  IBitCondition,
  IBitConditionBuilder,
  IBitStatCondition,
  IBitStatusCondition,
  IAbridgedBitBuilder
} from "./types";
import {
  baseComparators,
  comparators,
  gambitActions,
  fromAbridgedCondition
} from "./gambitFactory";

const fakeTargets: IBitBuilder["targets"] = [
  // { key: "all", enabled: false },
  { key: "foe", enabled: true },
  { key: "self", enabled: true }
];

const fakeActions: IBitBuilder["actions"] = Object.values(
  gambitActions
).map(action => ({ ...action, enabled: true }));

const conditionBuilder = <T extends IBitCondition>({
  lefts,
  keys,
  rights
}: IBitConditionBuilder<T>) =>
  lefts
    .map(left =>
      keys.map(key =>
        rights.map(right => ({
          left,
          key,
          right,
          enabled: true
        }))
      )
    )
    .flat(2);

const generateAllStatConditions = (): IBitBuilder["conditions"] => {
  const lefts: "hp"[] = ["hp"];
  const keys = comparators;
  const percentages = Array(10)
    .fill(null)
    .map((_, i) => i / 10);

  return conditionBuilder<IBitStatCondition>({
    lefts,
    keys,
    rights: percentages
  });
};

const generateAllStatusConditions = (): IBitBuilder["conditions"] => {
  const lefts: IBitStatusCondition["left"][] = ["status"];
  const keys = baseComparators;
  const rights: IBitStatusCondition["right"][] = ["poison"];

  return conditionBuilder<IBitStatusCondition>({ lefts, keys, rights });
};

export const generateAllConditions = () =>
  generateAllStatConditions().concat(generateAllStatusConditions());

export const generateAllBits = (): IBitBuilder => ({
  targets: fakeTargets,
  conditions: generateAllConditions(),
  actions: fakeActions
});

export const generateFromAbridgedBits = (
  abridgedBitBuilder: IAbridgedBitBuilder
): IBitBuilder => {
  const result: IBitBuilder = { targets: [], conditions: [], actions: [] };
  const { targets, conditions, actions } = abridgedBitBuilder;
  if (targets) {
    targets.forEach(key => {
      result.targets.push({ key, enabled: true });
    });
  }
  if (conditions) {
    conditions.forEach(abridgedCondition => {
      result.conditions.push({
        ...fromAbridgedCondition(abridgedCondition),
        enabled: true
      });
    });
  }
  if (actions) {
    actions.forEach(key => {
      if (gambitActions[key])
        result.actions.push({ ...gambitActions[key], enabled: true });
    });
  }
  return result;
};
